import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-slider', {
    month: {
        1: 'mēnesis',
        2: 'mēneši',
    },
    year: {
        1: 'gads',
        2: 'gadi',
    },
    value: 'Vērtību',
    minValue: 'Minimālā vērtība ir',
    maxValue: 'Maksimālā vērtība ir',
});
